import React from 'react';
import styles from '../styles/AlliedServices.module.scss';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import CustomImage from './CustomImage';
import NeedGuidance from './NeedGuidance';
import Button  from 'react-bootstrap/Button';
import { isFrappeOrJotFormClass } from '../utils/helpers';

const AlliedServicesComponent: React.FC = (props: any) => {
  const alliedServices = props.pageData;
  const alliedServicesLanding = props.pageDataLanding;
  
  return (
    <>
      <div id="allied-services" className={styles.aliedServices}>
        <div id='banner' className={styles.banner} >
          <Container>
            <div className={styles.breadcrum}>
              <Row className="text-center">
                <Col lg={8} md={8} xs={12} className={styles.centered}>
                  <Breadcrumb>
                    <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item href=""> Allied Services </Breadcrumb.Item>
                  </Breadcrumb>
                  <div className={styles.abttopContent}>
                    <div className={styles.abttopContentdesk} >
                      <h1>{alliedServicesLanding?.title}</h1>
                      <p> {alliedServicesLanding?.description}</p>
                      <Button
                    id='enquirebtn'
                    variant='primary'
                    size='lg'
                    className={`${styles.enquireBannerBtn} btn ${isFrappeOrJotFormClass(alliedServicesLanding?.meta?.jotforms[0]?.jotformid || process.env.NEXT_PUBLIC_COMMON_JOTFORM_ID)}`}>  {alliedServicesLanding?.bannerBtn?.label|| 'Enquire Now'}</Button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
              </Row>
            </div>
          </Container>
        </div>
        {/* Desktop view */}
        <div>
          <div className={styles.card}>
            <Container>
              <div className={styles.box}>
                <Row >
                  {alliedServices?.length > 0 &&
                    alliedServices.map((alliedData: any, index: number) => (
                      <Col xl={4} lg={4} md={6} sm={6} xs={12} className={styles.cardDiv} key={index}>
                        <div className={styles.webCard}>
                          <div className={styles.eventCardImg}>
                            <CustomImage src={alliedData?.card?.img?.url} alt={'card-img'} layout="responsive" width={370} height={220} className={styles.cardImg} />
                          </div>
                          <Card.Body id="cardBody" className={styles.cardBody}>
                            <Card.Title className={styles.mainTitle}> <h5>{alliedData?.card?.title}</h5> </Card.Title>
                            <p className={styles.para}>{alliedData?.card?.description}</p>
                            <div className={styles.button}>
                                <button
                                  className={`${styles.enquirebtn
                                    } ${isFrappeOrJotFormClass(alliedServicesLanding?.meta?.jotforms[0].jotformid)}`}
                                >
                                  Enquire Now
                                </button>
                              {alliedData?.card?.knowMoreLink &&
                                <a href={alliedData?.card?.knowMoreLink} className={styles.knowMore} >
                                  Know more
                                </a>
                             }
                            </div>
                          </Card.Body>
                        </div>
                      </Col>
                    )
                    )
                  }
                </Row>
              </div>
            </Container>
          </div>
        </div>
      </div>
      <NeedGuidance classname={`${isFrappeOrJotFormClass(alliedServicesLanding?.meta?.jotforms[0]?.jotformid)}`} />
    </>
  );
}
export default AlliedServicesComponent;